import { T as ToggleWrapper, a as ToggleLabel, b as ToggleBase, c as ToggleSwitch, d as ToggleLabelText, m as media } from './media-9903a289.js';
export { S as ScreenSize, i as Textfield, I as TextfieldInput, j as TextfieldSymbol, V as ValidationMessage, g as darken, e as focus, f as font, h as getBreakpoints, m as media, t as typography } from './media-9903a289.js';
import { a as applyColor, E as Ellipsis, b as EllipsisWithLineClamp } from './ThemeProvider-8e6424a4.js';
export { E as Ellipsis, b as EllipsisWithLineClamp, T as ThemeProvider, l as lighten, t as theme } from './ThemeProvider-8e6424a4.js';
import { B as Button$1, C as Column } from './Modal-6fd3c36b.js';
export { a as BlurFilter, B as Button, C as Column, L as LoadingSpinner, c as LoadingWarren, M as Modal, R as Row, b as buttonCSS, l as loadingAnimation } from './Modal-6fd3c36b.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useState, useRef, useEffect, isValidElement, cloneElement, useCallback } from 'react';
export { C as CrossSolid } from './CrossSolid-52de5c52.js';
import styled, { css } from 'styled-components';
export { A as AddToListSolid, a as AddToPortfolioOutline, b as AnnouncementOutline, c as ArrowRightSolid, d as ArticleOutline, B as BinSolid, e as BoardMembersOutline, C as CalendarOutline, f as ChartStandOutline, g as CheckSolid, h as ChevronDownSmallSolid, i as ChevronLeftEndSolid, j as ChevronLeftSolid, k as ChevronRightEndSolid, l as ChevronRightSmallSolid, m as ChevronRightSolid, n as CompanyOutline, o as CopyLinkOutline, D as DangerSolid, p as DiscoverOutline, q as DiscoverSolid, r as DownSolid, s as DownloadImageSolid, t as DownloadPdfSolid, u as DownloadReportSolid, v as DownloadXlsSolid, E as EditOutline, w as EditSolid, x as ExecutiveOutline, y as ExecutiveSmallOutline, z as EyeSolid, F as FilterOutline, G as FvOutline, H as FvSolid, I as HomeOutline, J as HomeSolid, K as InfoDescriptionSolid, L as InformationSolid, M as LineDownOutline, N as LineUpOutline, O as LinkOutline, P as ListSolid, Q as MarketInsightsOutline, R as MenuSolid, S as MoreHorizontalBoldOutline, T as MoreHorizontalBoldSolid, U as MoreHorizontalSolid, V as MoreVerticalSolid, W as OpenNewWindowOutline, X as PlusSolid, Y as PortfolioOutline, Z as PortfolioSolid, _ as QuestionMarkOutline, $ as ResetSolid, a0 as RewardSolid, a1 as ScreenerOutline, a2 as ScreenerSolid, a3 as SearchSolid, a4 as SmileyNeutralSolid, a5 as SortingOutline, a6 as StatementNegativeSolid, a7 as StatementNoDataSolid, a8 as StatementPositiveSolid, a9 as StatementWarningSolid, aa as StocksOutline, ab as StocksSolid, ac as SuccessSolid, ad as SupportSolid, ae as TableSolid, af as TickSolid, ag as TilesSolid, ah as TransferSolid, ai as UserOutline, aj as WarningSolid, ak as WatchlistOutline, al as WatchlistSolid, am as WatchlistStarOutline, an as WatchlistStarSolid } from './WatchlistStarSolid-354ee670.js';
export { default as BoardChangeOutline } from './BoardChangeOutline.esm.js';
export { default as BreakEvenOutline } from './BreakEvenOutline.esm.js';
export { default as ChartDownOutline } from './ChartDownOutline.esm.js';
export { default as ChartUpOutline } from './ChartUpOutline.esm.js';
export { default as DividendOutline } from './DividendOutline.esm.js';
export { default as EarningReportOutline } from './EarningReportOutline.esm.js';
export { default as ExecutiveLeavingOutline } from './ExecutiveLeavingOutline.esm.js';
export { default as ExecutiveOverboardingOutline } from './ExecutiveOverboardingOutline.esm.js';
export { default as ForecastDowngradeOutline } from './ForecastDowngradeOutline.esm.js';
export { default as ForecastOutline } from './ForecastOutline.esm.js';
export { default as ForecastUpgradeOutline } from './ForecastUpgradeOutline.esm.js';
export { default as InsiderDownOutline } from './InsiderDownOutline.esm.js';
export { default as InsiderUpOutline } from './InsiderUpOutline.esm.js';
export { default as PeOutline } from './PeOutline.esm.js';
export { default as PriceDownOutline } from './PriceDownOutline.esm.js';
export { default as PriceUpOutline } from './PriceUpOutline.esm.js';
export { default as ValuationOutline } from './ValuationOutline.esm.js';
export { b as useIsMounted, a as useMount, u as useTheme } from './useMount-b898f7c5.js';
import 'react-dom';

const Toggle = _ref => {
  let {
    name,
    value,
    label,
    tabIndex,
    readOnly,
    autoFocus,
    disabled = false,
    onChange,
    onFocus,
    onBlur,
    styleType = 'dark',
    display = 'inline-block'
  } = _ref;
  return jsx(ToggleWrapper, {
    disabled: disabled,
    display: display,
    children: jsxs(ToggleLabel, {
      "data-cy-id": `toggle-label-${name}`,
      children: [jsx("input", {
        name: name,
        type: "checkbox",
        checked: value,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        tabIndex: tabIndex || 0,
        onBlur: onBlur,
        onFocus: onFocus,
        onChange: e => {
          onChange && onChange(e);
        },
        "data-cy-id": `toggle-btn-${name}`
      }), jsx(ToggleBase, {
        styleType: styleType,
        children: jsx(ToggleSwitch, {})
      }), label ? jsx(ToggleLabelText, {
        children: label
      }) : null]
    })
  });
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const ButtonWrapper = styled('div')`
  display: inline-block;
  width: auto;
  position: relative;
`;
const DropdownWrapper = styled('div')`
  position: absolute;
  width: 100%;
  ${_ref => {
  let {
    dropUp
  } = _ref;
  return dropUp && css`
      top: 0;
    `;
}};
`;
const Dropdown = styled('div')`
  position: absolute;
  z-index: 1;
  ${_ref2 => {
  let {
    dropUp,
    marginTop,
    marginBottom,
    theme
  } = _ref2;

  if (dropUp) {
    return css`
        bottom: ${marginTop ? 0 : theme.x1spacePx / 2}px;
      `;
  }

  return css`
      top: ${marginBottom ? 0 : theme.x1spacePx / 2}px;
    `;
}};
  ${_ref3 => {
  let {
    floatLeft,
    marginLeft,
    marginRight,
    theme
  } = _ref3;
  return floatLeft ? css`
          left: ${marginLeft ? theme.x1spacePx / 2 : 0}px;
        ` : css`
          right: ${marginRight ? theme.x1spacePx / 2 : 0}px;
        `;
}};
  background: white;
  border: 1px solid ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.color.surface.x5;
}};
  padding: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.x1spacePx;
}}px 0;
  border-radius: 4px;
  > hr {
    margin: 8px 0;
    border-color: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.color.surface.x5;
}};
  }
  display: inline-block;
  width: auto;
`;
const DropdownButton = styled('button')`
  ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.typography.xSmall;
}};
  color: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme.color.black;
}};
  display: flex;
  align-items: center;
  white-space: nowrap;
  user-select: none;
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  transition: background 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  padding: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.x1spacePx;
}}px
    ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.x2spacePx;
}}px;
  ${media.mdUp`
    &:hover {
      background: ${_ref11 => {
  let {
    theme
  } = _ref11;
  return theme.color.brand01;
}};
      color: ${_ref12 => {
  let {
    theme
  } = _ref12;
  return theme.color.white;
}};
      > svg {
        fill: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme.color.white;
}};
      }
    }
  `}

  > svg {
    opacity: 0.5;
    margin-left: -4px;
    height: 24px;
    width: 24px;
    padding-right: ${_ref14 => {
  let {
    theme
  } = _ref14;
  return theme.x4space;
}}px;
    fill: ${_ref15 => {
  let {
    theme
  } = _ref15;
  return theme.color.black;
}};
    transition: fill 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  }
`;

const DropdownMenu = _ref => {
  let {
    options,
    dropUp,
    secondaryOptions,
    floatLeft,
    marginTop,
    marginLeft,
    marginRight,
    marginBottom
  } = _ref;
  return jsx(DropdownWrapper, {
    dropUp: dropUp,
    children: jsxs(Dropdown, {
      floatLeft: floatLeft,
      dropUp: dropUp,
      marginTop: marginTop,
      marginLeft: marginLeft,
      marginRight: marginRight,
      marginBottom: marginBottom,
      children: [options.map(DropDownButton => DropDownButton), secondaryOptions && secondaryOptions.length > 0 && jsx("hr", {}), secondaryOptions && secondaryOptions.length && secondaryOptions.map(DropDownButton => DropDownButton)]
    })
  });
};

const _excluded$2 = ["children", "options", "dropUp", "styleType", "secondaryOptions", "headerText", "floatLeft", "marginTop", "marginLeft", "marginRight", "marginBottom", "alignIcon", "onSelect", "onClick"];
const getDropDownButton = (onSelect, onTouchSelect, onBlur, onFocus, styleType, options) => {
  return options.map((option, i) => {
    if (isValidElement(option)) {
      const childProps = {
        onTouchEnd: onTouchSelect,
        onBlur,
        onFocus,
        onSelect,
        styleType,
        key: `DropdownButton-${i}`
      };
      return cloneElement(option, childProps);
    } else {
      return jsxs(DropdownButton, {
        as: "a",
        tabIndex: -1,
        styleType: styleType,
        "data-cy-id": `dropdown-button-${i}`,
        onBlur: onBlur,
        onFocus: onFocus,
        onClick: () => onSelect === null || onSelect === void 0 ? void 0 : onSelect(option.value, option.label),
        onTouchEnd: e => {
          e.preventDefault();
          onTouchSelect(e.changedTouches[0].pageY, option.value, option.label);
        },
        children: [option.icon, option.label]
      }, `DropdownButton-${i}`);
    }
  });
};
const ButtonWithDropdown = _ref => {
  let {
    children,
    options,
    dropUp,
    styleType,
    secondaryOptions,
    headerText,
    floatLeft,
    marginTop,
    marginLeft,
    marginRight,
    marginBottom,
    alignIcon,
    onSelect,
    onClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  const [isActive, setIsActive] = useState(false);
  const ref = useRef(null); //

  let startY = 0;
  let queue = 0; //

  const handleTouchStart = e => {
    const touch = e.changedTouches[0];
    startY = touch.pageY;
  };

  const handleTouchEnd = e => {
    const {
      current
    } = ref;
    const touch = e.changedTouches[0];

    if (isActive && current && Math.abs(touch.pageY - startY) < 1) {
      current.blur();
    }
  }; //


  useEffect(() => {
    document.addEventListener('keyup', handleKeyUp);
    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchend', handleTouchEnd);
    return () => {
      document.removeEventListener('keyup', handleKeyUp);
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTouchEnd, handleTouchStart]);

  const handleKeyUp = e => {
    const {
      current
    } = ref;

    switch (e.keyCode) {
      case 27:
        if (current) {
          current.blur();
        }

        break;
    }
  };

  const handleClick = e => {
    onClick && onClick();
    e.stopPropagation();
    e.preventDefault();
    const {
      current
    } = ref;

    if (current) {
      if (!isActive && document.activeElement !== current) {
        current.focus();
      }
    }
  };

  const handleTouchSelect = (yPos, value, label) => {
    if (Math.abs(yPos - startY) < 1) {
      handleSelect(value, label);
    }
  };

  const handleSelect = (value, label) => {
    setIsActive(false);
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(value, label);
  };

  const handleFocus = () => {
    window.clearTimeout(queue);
    setIsActive(true);
  };

  const handleBlur = () => {
    // Using a queuing system for help tune for accessibility https://stackoverflow.com/a/38317768/2248347
    queue = window.setTimeout(() => {
      setIsActive(false);
    }, 0);
  };

  const shouldRenderDropdownMenu = isActive && (options.length > 0 || secondaryOptions && secondaryOptions.length > 0);
  return jsxs(ButtonWrapper, Object.assign({}, props, {
    children: [jsx(Button$1, {
      ref: ref,
      "data-active": isActive,
      styleType: styleType,
      onBlur: handleBlur,
      onFocus: handleFocus,
      onClick: handleClick,
      alignIcon: alignIcon,
      marginTop: marginTop,
      marginLeft: marginLeft,
      marginRight: marginRight,
      marginBottom: marginBottom,
      children: children
    }), shouldRenderDropdownMenu && jsx(DropdownMenu, {
      options: getDropDownButton(handleSelect, handleTouchSelect, handleBlur, handleFocus, styleType, options),
      secondaryOptions: secondaryOptions && getDropDownButton(handleSelect, handleTouchSelect, handleBlur, handleFocus, styleType, secondaryOptions),
      headerText: headerText,
      styleType: styleType,
      dropUp: dropUp,
      floatLeft: floatLeft,
      marginTop: marginTop,
      marginLeft: marginLeft,
      marginRight: marginRight,
      marginBottom: marginBottom,
      onBlur: handleBlur,
      onFocus: handleFocus,
      onSelect: handleSelect,
      onTouchSelect: handleTouchSelect
    })]
  }));
};

const getDisplay = display => css`
  display: ${display};
`;

const getGap = gap => css`
  grid-gap: ${gap};
`;

const getRowGap = gap => css`
  grid-row-gap: ${gap};
`;

const getColumnGap = gap => css`
  grid-column-gap: ${gap};
`;

const getTemplate = template => css`
  grid-template: ${template};
`;

const getTemplateColumns = templateColumns => css`
  grid-template-columns: ${templateColumns};
`;

const getTemplateRows = templateRows => css`
  grid-template-rows: ${templateRows};
`;

const getJustifyItems = alignment => css`
  justify-items: ${alignment};
`;

const getJustifyContent = alignment => css`
  justify-content: ${alignment};
`;

const getAlignItems = alignment => css`
  align-items: ${alignment};
`;

const getAlignContent = alignment => css`
  align-content: ${alignment};
`;

const getPlaceItems = alignment => css`
  place-items: ${alignment};
`;

const getPlaceContent = alignment => css`
  place-content: ${alignment};
`;

const getRow = row => css`
  grid-row: ${row};
`;

const getColumn = column => css`
  grid-column: ${column};
`;

const Grid = styled('div')`
  /* Display */
  ${_ref => {
  let {
    display = 'grid'
  } = _ref;
  return display && getDisplay(display);
}}
  /* Gaps */
  ${_ref2 => {
  let {
    gap
  } = _ref2;
  return gap && getGap(gap);
}}
  ${_ref3 => {
  let {
    rowGap
  } = _ref3;
  return rowGap && getRowGap(rowGap);
}}
  ${_ref4 => {
  let {
    columnGap
  } = _ref4;
  return columnGap && getColumnGap(columnGap);
}}
  /* Template */
  ${_ref5 => {
  let {
    template
  } = _ref5;
  return template && getTemplate(template);
}}
  ${_ref6 => {
  let {
    templateColumns
  } = _ref6;
  return templateColumns && getTemplateColumns(templateColumns);
}}
  ${_ref7 => {
  let {
    templateRows
  } = _ref7;
  return templateRows && getTemplateRows(templateRows);
}}
  /* Alignment */
  ${_ref8 => {
  let {
    justifyItems
  } = _ref8;
  return justifyItems && getJustifyItems(justifyItems);
}}
  ${_ref9 => {
  let {
    justifyContent
  } = _ref9;
  return justifyContent && getJustifyContent(justifyContent);
}}
  ${_ref10 => {
  let {
    alignItems
  } = _ref10;
  return alignItems && getAlignItems(alignItems);
}}
  ${_ref11 => {
  let {
    alignContent
  } = _ref11;
  return alignContent && getAlignContent(alignContent);
}}
  ${_ref12 => {
  let {
    placeItems
  } = _ref12;
  return placeItems && getPlaceItems(placeItems);
}}
  ${_ref13 => {
  let {
    placeContent
  } = _ref13;
  return placeContent && getPlaceContent(placeContent);
}}
  /* Child Properties */
  ${_ref14 => {
  let {
    row
  } = _ref14;
  return row && getRow(row);
}}
  ${_ref15 => {
  let {
    column
  } = _ref15;
  return column && getColumn(column);
}}
  /*
    media.smUp
  */
  ${_ref16 => {
  let {
    displaySm,
    gapSm,
    rowGapSm,
    columnGapSm,
    templateSm,
    templateColumnsSm,
    templateRowsSm,
    justifyItemsSm,
    justifyContentSm,
    alignItemsSm,
    alignContentSm,
    placeItemsSm,
    placeContentSm,
    rowSm,
    columnSm
  } = _ref16;

  if (displaySm || gapSm || rowGapSm || columnGapSm || templateSm || templateColumnsSm || templateRowsSm || justifyItemsSm || justifyContentSm || alignItemsSm || alignContentSm || placeItemsSm || placeContentSm || rowSm || columnSm) {
    return media.smUp`
        /* Display */
        ${displaySm && getDisplay(displaySm)};
        /* Gaps */
        ${gapSm && getGap(gapSm)}
        ${rowGapSm && getRowGap(rowGapSm)}
        ${columnGapSm && getColumnGap(columnGapSm)}
        /* Template */
        ${templateSm && getTemplate(templateSm)}
        ${templateColumnsSm && getTemplateColumns(templateColumnsSm)}
        ${templateRowsSm && getTemplateRows(templateRowsSm)}
        /* Alignment */
        ${justifyItemsSm && getJustifyItems(justifyItemsSm)}
        ${justifyContentSm && getJustifyContent(justifyContentSm)}
        ${alignItemsSm && getAlignItems(alignItemsSm)}
        ${alignContentSm && getAlignContent(alignContentSm)}
        ${placeItemsSm && getPlaceItems(placeItemsSm)}
        ${placeContentSm && getPlaceContent(placeContentSm)}
        /* Child Properties */
        ${rowSm && getRow(rowSm)}
        ${columnSm && getColumn(columnSm)}
      `;
  }
}}
  /*
    media.mdUp
  */
  ${_ref17 => {
  let {
    displayMd,
    gapMd,
    rowGapMd,
    columnGapMd,
    templateMd,
    templateColumnsMd,
    templateRowsMd,
    justifyItemsMd,
    justifyContentMd,
    alignItemsMd,
    alignContentMd,
    placeItemsMd,
    placeContentMd,
    rowMd,
    columnMd
  } = _ref17;

  if (displayMd || gapMd || rowGapMd || columnGapMd || templateMd || templateColumnsMd || templateRowsMd || justifyItemsMd || justifyContentMd || alignItemsMd || alignContentMd || placeItemsMd || placeContentMd || rowMd || columnMd) {
    return media.mdUp`
        /* Display */
        ${displayMd && getDisplay(displayMd)};
        /* Gaps */
        ${gapMd && getGap(gapMd)}
        ${rowGapMd && getRowGap(rowGapMd)}
        ${columnGapMd && getColumnGap(columnGapMd)}
        /* Template */
        ${templateMd && getTemplate(templateMd)}
        ${templateColumnsMd && getTemplateColumns(templateColumnsMd)}
        ${templateRowsMd && getTemplateRows(templateRowsMd)}
        /* Alignment */
        ${justifyItemsMd && getJustifyItems(justifyItemsMd)}
        ${justifyContentMd && getJustifyContent(justifyContentMd)}
        ${alignItemsMd && getAlignItems(alignItemsMd)}
        ${alignContentMd && getAlignContent(alignContentMd)}
        ${placeItemsMd && getPlaceItems(placeItemsMd)}
        ${placeContentMd && getPlaceContent(placeContentMd)}
        /* Child Properties */
        ${rowMd && getRow(rowMd)}
        ${columnMd && getColumn(columnMd)}
      `;
  }
}}
  /*
    media.lgUp
  */
  ${_ref18 => {
  let {
    displayLg,
    gapLg,
    rowGapLg,
    columnGapLg,
    templateLg,
    templateColumnsLg,
    templateRowsLg,
    justifyItemsLg,
    justifyContentLg,
    alignItemsLg,
    alignContentLg,
    placeItemsLg,
    placeContentLg,
    rowLg,
    columnLg
  } = _ref18;

  if (displayLg || gapLg || rowGapLg || columnGapLg || templateLg || templateColumnsLg || templateRowsLg || justifyItemsLg || justifyContentLg || alignItemsLg || alignContentLg || placeItemsLg || placeContentLg || rowLg || columnLg) {
    return media.lgUp`
        /* Display */
        ${displayLg && getDisplay(displayLg)};
        /* Gaps */
        ${gapLg && getGap(gapLg)}
        ${rowGapLg && getRowGap(rowGapLg)}
        ${columnGapLg && getColumnGap(columnGapLg)}
        /* Template */
        ${templateLg && getTemplate(templateLg)}
        ${templateColumnsLg && getTemplateColumns(templateColumnsLg)}
        ${templateRowsLg && getTemplateRows(templateRowsLg)}
        /* Alignment */
        ${justifyItemsLg && getJustifyItems(justifyItemsLg)}
        ${justifyContentLg && getJustifyContent(justifyContentLg)}
        ${alignItemsLg && getAlignItems(alignItemsLg)}
        ${alignContentLg && getAlignContent(alignContentLg)}
        ${placeItemsLg && getPlaceItems(placeItemsLg)}
        ${placeContentLg && getPlaceContent(placeContentLg)}
        /* Child Properties */
        ${rowLg && getRow(rowLg)}
        ${columnLg && getColumn(columnLg)}
      `;
  }
}}
    
  /*
    media.xlUp
  */
  ${_ref19 => {
  let {
    displayXl,
    gapXl,
    rowGapXl,
    columnGapXl,
    templateXl,
    templateColumnsXl,
    templateRowsXl,
    justifyItemsXl,
    justifyContentXl,
    alignItemsXl,
    alignContentXl,
    placeItemsXl,
    placeContentXl,
    rowXl,
    columnXl
  } = _ref19;

  if (displayXl || gapXl || rowGapXl || columnGapXl || templateXl || templateColumnsXl || templateRowsXl || justifyItemsXl || justifyContentXl || alignItemsXl || alignContentXl || placeItemsXl || placeContentXl || rowXl || columnXl) {
    return media.xlUp`
        /* Display */
        ${displayXl && getDisplay(displayXl)};
        /* Gaps */
        ${gapXl && getGap(gapXl)}
        ${rowGapXl && getRowGap(rowGapXl)}
        ${columnGapXl && getColumnGap(columnGapXl)}
        /* Template */
        ${templateXl && getTemplate(templateXl)}
        ${templateColumnsXl && getTemplateColumns(templateColumnsXl)}
        ${templateRowsXl && getTemplateRows(templateRowsXl)}
        /* Alignment */
        ${justifyItemsXl && getJustifyItems(justifyItemsXl)}
        ${justifyContentXl && getJustifyContent(justifyContentXl)}
        ${alignItemsXl && getAlignItems(alignItemsXl)}
        ${alignContentXl && getAlignContent(alignContentXl)}
        ${placeItemsXl && getPlaceItems(placeItemsXl)}
        ${placeContentXl && getPlaceContent(placeContentXl)}
        /* Child Properties */
        ${rowXl && getRow(rowXl)}
        ${columnXl && getColumn(columnXl)}
      `;
  }
}}
`;

const disabled$1 = css`
  cursor: auto;
`;
const hover$1 = css`
  background: ${_ref => {
  let {
    theme,
    styleType
  } = _ref;
  if (styleType === 'subnav') return 'transparent';
  return theme.color.whiteRGBA(0.1);
}};
`;
const select = css`
  color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.color.white;
}};
  ${_ref3 => {
  let {
    theme,
    styleType
  } = _ref3;

  if (styleType === 'period') {
    return `background: ${theme.color.blackRGBA(0.3)};`;
  }

  if (styleType === 'subnav') {
    return `box-shadow: 0px -${theme.x1spacePx / 2}px 0px 0px inset ${theme.color.brand01};`;
  }

  return `
      border-color: ${theme.color.whiteRGBA(0.1)};
      border-bottom-color: transparent;
    `;
}}
`;
const padding = css`
  padding: ${_ref4 => {
  let {
    theme,
    styleType
  } = _ref4;

  if (styleType === 'period') {
    return `${theme.x1spacePx / 2}px ${theme.x1spacePx / 2}px`;
  }

  if (styleType === 'subnav') {
    return `0px ${theme.x2spacePx}px ${theme.x1spacePx / 2}px`;
  }

  return `${theme.x1spacePx}px ${theme.x2spacePx}px`;
}};
`;
const border = css`
  border: ${_ref5 => {
  let {
    styleType
  } = _ref5;

  if (styleType === 'subnav') {
    return `none`;
  }

  return `1px solid transparent`;
}};
`;
const height = css`
  height: ${_ref6 => {
  let {
    theme,
    styleType
  } = _ref6;

  if (styleType === 'subnav') {
    return `${theme.x6spacePx}px`;
  }

  return `auto`;
}};
`;
const typography = css`
  ${_ref7 => {
  let {
    theme,
    styleType
  } = _ref7;

  if (styleType === 'subnav') {
    return theme.typography.xSmall;
  }

  return theme.typography.xSmallStrong;
}}
`;
const tabCSS = css`
  display: block;
  position: relative;
  width: 100%;
  ${height}
  ${border}
  ${_ref8 => {
  let {
    styleType,
    theme
  } = _ref8;
  return styleType === 'period' && `border-radius: ${theme.x1spacePx / 2}px;`;
}}
  ${typography}
  color: ${_ref9 => {
  let {
    styleType,
    theme
  } = _ref9;
  return theme.color.whiteRGBA(styleType === 'period' ? 0.3 : 0.5);
}};
  ${padding}
  &:disabled {
    ${disabled$1}
  }
  ${media.lgUp`
    &:hover:not(:disabled) {
      ${hover$1};
    }
  `}
  ${_ref10 => {
  let {
    selected
  } = _ref10;
  return selected && select;
}};
`;
const Button = styled('button')`
  ${tabCSS}
`;

const Tab = _ref => {
  let {
    col,
    value,
    order,
    selected = false,
    disabled,
    children,
    onSelect,
    alignItem,
    styleType = 'default',
    name,
    render
  } = _ref;
  const handleClick = useCallback(() => {
    if (typeof value === 'undefined') return;
    if (typeof onSelect === 'undefined') return;
    onSelect(value);
  }, [value, onSelect]);
  return jsx(Column, {
    col: col,
    order: order,
    fillVoid: col || alignItem ? false : true,
    alignItem: alignItem,
    width: alignItem ? 'auto' : undefined,
    children: typeof render !== 'undefined' ? jsx(Fragment, {
      children: render
    }) : jsx(Button, {
      styleType: styleType,
      selected: selected,
      disabled: disabled || selected,
      onClick: handleClick,
      "data-cy-id": name,
      "data-testid": "tab-button",
      children: children
    })
  });
};

const svg = css`
  ${_ref => {
  let {
    theme,
    alignIcon
  } = _ref;
  const dimensions = theme.x3spacePx;
  return css`
      > svg {
        display: inline;
        fill: ${theme.color.white};
        opacity: 0.5;
        width: ${dimensions}px;
        height: ${dimensions}px;
        vertical-align: middle;
        ${alignIcon && css`
          padding-${alignIcon}: 4px;
        `}
      }
    `;
}}
`;
const disabled = css`
  cursor: auto;
  pointer-events: none;
  opacity: 0.3;
  color: ${_ref2 => {
  let {
    theme,
    styleType
  } = _ref2;

  switch (styleType) {
    case 'strong':
      return theme.color.whiteRGBA(0.7);

    default:
      return theme.color.white;
  }
}};
  background-color: ${_ref3 => {
  let {
    theme,
    styleType
  } = _ref3;

  switch (styleType) {
    case 'strong':
      return theme.color.brand01RGBA(0.3);

    default:
      return 'transparent';
  }
}};
`;
const hover = css`
  background-color: ${_ref4 => {
  let {
    theme,
    styleType,
    state
  } = _ref4;

  switch (styleType) {
    case 'subtle':
      return theme.color.whiteRGBA(0.1);

    case 'strong':
      return state == 'off' ? theme.color.whiteRGBA(0.1) : theme.color.brand01;
  }
}};
`;
const backgroundColor = css`
  background-color: ${_ref5 => {
  let {
    theme,
    styleType,
    state
  } = _ref5;

  if (state == 'off') {
    return 'transparent';
  }

  switch (styleType) {
    case 'subtle':
      return theme.color.whiteRGBA(0.2);

    case 'strong':
      return theme.color.brand01;
  }
}};
`;
const toggleButtonCss = css`
  ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.typography.tiny;
}}
  &:disabled {
    ${disabled}
  }
  &:hover,
  &:visited {
    ${hover}
  }
  position: relative;
  display: inline-flex;
  align-items: center;
  height: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.x4spacePx - 4;
}}px;
  line-height: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme.x4spacePx - 4;
}}px;
  color: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.color.white;
}};
  vertical-align: middle;
  border-radius: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.x1spacePx / 2;
}}px;
  padding: ${_ref11 => {
  let {
    theme
  } = _ref11;
  return `0 ${theme.x2spacePx - 4}px`;
}};
  ${backgroundColor}
  ${svg}
`;
const ToggleButton = styled('button').attrs(_ref12 => {
  let {
    theme
  } = _ref12;
  return Object.assign({}, theme.focus('dashed'));
})`
  ${toggleButtonCss}
`;

const colorFor = {
  p: 'white',
  h1: 'white',
  h2: 'white',
  h3: 'white',
  h4: 'white',
  h5: 'white',
  h6: 'white',
  span: 'inherit'
};
const typographyFor = {
  p: 'base',
  h1: 'mega',
  h2: 'xLarge',
  h3: 'large',
  h4: 'large',
  h5: 'base',
  h6: 'base',
  span: 'inherit'
};

const StyledText = styled('span')`
  margin: 0;
  ${_ref => {
  let {
    theme,
    typography
  } = _ref;
  return theme.typography[typography];
}}
  color: ${_ref2 => {
  let {
    theme,
    $color,
    $opacity
  } = _ref2;

  if ($color === 'inherit') {
    return 'inherit';
  }

  return applyColor(theme.color[$color], $opacity);
}};
  ${_ref3 => {
  let {
    textAlign
  } = _ref3;
  return textAlign && css`
      text-align: ${textAlign};
    `;
}}
  ${_ref4 => {
  let {
    textTransform
  } = _ref4;
  return textTransform && css`
      text-transform: ${textTransform};
    `;
}}
  ${_ref5 => {
  let {
    isTruncated
  } = _ref5;
  return isTruncated && Ellipsis;
}}
  ${_ref6 => {
  let {
    lineClamp
  } = _ref6;
  return typeof lineClamp !== 'undefined' && EllipsisWithLineClamp(lineClamp);
}}
`;

const _excluded$1 = ["as", "opacity", "textAlign", "textTransform", "color", "typography", "isTruncated", "lineClamp", "children"];

const Text = _ref => {
  let {
    as = 'p',
    opacity,
    textAlign,
    textTransform,
    color = colorFor[as],
    typography = typographyFor[as],
    isTruncated = false,
    lineClamp,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  return jsx(StyledText, Object.assign({
    as: as,
    "$color": color,
    "$opacity": opacity,
    textAlign: textAlign,
    textTransform: textTransform,
    typography: typography,
    isTruncated: isTruncated,
    lineClamp: lineClamp
  }, props, {
    children: children
  }));
};

const _excluded = ["as", "opacity", "textAlign", "textTransform", "color", "typography", "isTruncated", "lineClamp", "children"];

const Heading = _ref => {
  let {
    as,
    opacity,
    textAlign,
    textTransform,
    color = colorFor[as],
    typography = typographyFor[as],
    isTruncated = false,
    lineClamp,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return jsx(StyledText, Object.assign({
    as: as,
    "$color": color,
    "$opacity": opacity,
    textAlign: textAlign,
    typography: typography,
    textTransform: textTransform,
    isTruncated: isTruncated,
    lineClamp: lineClamp
  }, props, {
    children: children
  }));
};

export { ButtonWithDropdown, Grid, Heading, Tab, Text, Toggle, ToggleButton, tabCSS };
